import { render, staticRenderFns } from "./ghDataView.vue?vue&type=template&id=58d00be3&scoped=true&"
import script from "./ghDataView.vue?vue&type=script&lang=js&"
export * from "./ghDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d00be3",
  null
  
)

export default component.exports